import React, {createContext, useContext} from "react";
import {IconProps} from "./IconProps";

interface DynamicIconContextValue {
    icon:
        | [React.ComponentType<IconProps>]
        | [React.ComponentType<IconProps>, React.ComponentType<IconProps>]; // max 2 icons, first being close state, second being open state
    children: any;
}

const DynamicIconContext = createContext<DynamicIconContextValue | undefined>(
    undefined,
);

export const useDynamicIcon = () => {
    const context = useContext(DynamicIconContext);
    return context?.icon;
};

export const DynamicIconProvider: React.FC<DynamicIconContextValue> = ({
                                                                           icon,
                                                                           children,
                                                                       }) => {
    return (
        <DynamicIconContext.Provider value={{icon, children}}>
            {children}
        </DynamicIconContext.Provider>
    );
};
